import { required, Validator } from '@/entities/validation';
import { EntityType } from './model';
import { validate as validateProperty } from '@/entities/entityTypeProperty/validator';

export const validate: Validator<EntityType> = record => [
  ...required(record.title, 'title'),
  ...record.properties.flatMap((property, index) =>
    validateProperty(property).map(error => ({
      ...error,
      field: `properties.${index}.${error.field}`,
    }))),
];
